import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getFromLocalStorage(key) {
    return localStorage.getItem(key);
  }

  setToLocalStorage(key, val) {
    localStorage.setItem(key, val);
  }

  clearFromLocalStorage(key, removeAllItems = false) {
    removeAllItems ? localStorage.clear() : localStorage.removeItem(key);
  }

  setCookie(name: string, value: string, expireDays: number = 10, path: string = '') {
    let d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires = `expires=${d.toUTCString()}`;
    let cpath = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  getFromCookie(key) {
    const nameLenPlus = (key.length + 1);
    return document.cookie
      .split(';')
      .map(c => c.trim())
      .filter(cookie => {
        return cookie.substring(0, nameLenPlus) === `${key}=`;
      })
      .map(cookie => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || null;
  }

  deleteCookie(name) {
    this.setCookie(name, '', -1);
  }

  deleteAllCookies() {
    let cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  setSession(key, value) {
    sessionStorage.setItem(key, value)
  }

  getSession(key) {
    return sessionStorage.getItem(key);
  }

  deleteSession(key) {
    sessionStorage.removeItem(key)
  }
}
